import React, { useEffect, useState } from "react";

import BusinessIcon from "@mui/icons-material/Business";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, CircularProgress, Stack } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { useSelector } from "react-redux";

import { ButtonVariant } from "../Constant/button";
import { getBusinessSelectedAsync } from "../helpers/business/getBusiness";
import StandartButton from "./atoms/StandartButton";
import "./shared/header.css";

const BusinessSelect = (props) => {
    const bussiness = useSelector(
        (state) => state.allDashboardDatasState.getAllDashboardDatas.bussiness,
    );
    const [selectedBussiness, setSelectedBussiness] = useState(null);
    const [isSwitching, setIsSwitching] = useState(false);
    const [switchingId, setSwitchingId] = useState(null);

    useEffect(() => {
        if (bussiness && bussiness.length > 0) {
            setSelectedBussiness(
                [...bussiness].find((x) => x?.selected === true),
            );
        }
    }, [bussiness]);

    const getChangedBusiness = async (id) => {
        if (isSwitching) return;
        setIsSwitching(true);
        setSwitchingId(id);
        try {
            const result = await getBusinessSelectedAsync(id);
            if (result.status) {
                const leadRead = window.localStorage.getItem("lead_read");
                localStorage.clear();
                window.localStorage.setItem("lead_read", leadRead);
                window.location.href = result?.data?.login_url ?? "";
                return;
            }
        } finally {
            setIsSwitching(false);
            setSwitchingId(null);
        }
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [menuMinWidth, setMenuMinWidth] = useState(160);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setMenuMinWidth(event.currentTarget.offsetWidth || 160);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (bussiness && (bussiness.length === 0 || bussiness.length === 1)) {
        return (
            <Box minWidth="160px" maxWidth="220px">
                <StandartButton
                    id="basic-button"
                    variant={ButtonVariant.BLACK_OUTLINED}
                    fullWidth
                >
                    <Stack direction="row" gap={2} width="100%">
                        <Stack direction="row" gap={1} marginRight="auto">
                            <BusinessIcon></BusinessIcon>
                            <Box
                                textTransform="initial"
                                maxWidth="130px"
                                textOverflow="ellipsis"
                                overflow="hidden"
                                whiteSpace="nowrap"
                            >
                                {bussiness && bussiness[0]?.name}
                            </Box>
                        </Stack>
                    </Stack>
                </StandartButton>
            </Box>
        );
    } else {
        return (
            bussiness?.length > 1 && (
                <Box minWidth="160px" maxWidth="220px">
                    <StandartButton
                        id="basic-button"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        disabled={isSwitching}
                        variant={ButtonVariant.BLACK_OUTLINED}
                        fullWidth
                    >
                        <Stack direction="row" gap={2} width="100%">
                            <Stack direction="row" gap={1} marginRight="auto">
                                <BusinessIcon></BusinessIcon>
                                <Box
                                    textTransform="initial"
                                    maxWidth="130px"
                                    textOverflow="ellipsis"
                                    overflow="hidden"
                                    whiteSpace="nowrap"
                                >
                                    {bussiness &&
                                        selectedBussiness &&
                                        selectedBussiness?.name}
                                </Box>
                            </Stack>
                            {isSwitching ? (
                                <CircularProgress size={16} />
                            ) : (
                                <KeyboardArrowDownIcon
                                    sx={{
                                        transition: "transform 0.2s ease",
                                        transform: open
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                    }}
                                ></KeyboardArrowDownIcon>
                            )}
                        </Stack>
                    </StandartButton>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        disableScrollLock
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        MenuListProps={{
                            "aria-labelledby": "basic-button",
                        }}
                        PaperProps={{
                            style: {
                                minWidth: menuMinWidth,
                                maxWidth: 280,
                                marginTop: 0,
                            },
                        }}
                    >
                        {bussiness?.map((item) => {
                            return (
                                item.selected == false && (
                                    <MenuItem
                                        key={item.id}
                                        disabled={isSwitching}
                                        onClick={() =>
                                            getChangedBusiness(item.id)
                                        }
                                    >
                                        <Stack
                                            direction="row"
                                            gap={1}
                                            alignItems="center"
                                            width="100%"
                                        >
                                            <Box
                                                flex={1}
                                                overflow="hidden"
                                                textOverflow="ellipsis"
                                                whiteSpace="nowrap"
                                            >
                                                {item.name}
                                            </Box>
                                            {switchingId === item.id && (
                                                <CircularProgress size={14} />
                                            )}
                                        </Stack>
                                    </MenuItem>
                                )
                            );
                        })}
                    </Menu>
                </Box>
            )
        );
    }
};

export default BusinessSelect;
